import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import bruceLee from '../images/quotes/bruce-lee@2x.png';
import anneFrank from '../images/quotes/anne-frank@2x.png';
import picasso from '../images/quotes/picasso@2x.png';
import henryFord from '../images/quotes/henry-ford@2x.png';
import dalaiLama from '../images/quotes/dalai-lama@2x.png';
import spongebob from '../images/quotes/spongebob@2x.png';
import cohen from '../images/quotes/cohen@2x.png';
import quasimodo from '../images/quotes/quasimodo@2x.png';
import einstein from '../images/quotes/einstein@2x.png';
import daVinci from '../images/quotes/da-vinci@2x.png';
import peterBlock from '../images/quotes/peter-block@2x.png';

const quotes = [
    {
        quote: 'If you spend too much time thinking about a thing, you\'ll never get it done.',
        author: 'Bruce Lee',
        authorRole: 'Martial Artist',
        authorImage: bruceLee
    },
    {
        quote: 'How wonderful it is that nobody need wait a single moment before starting to improve the world.',
        author: 'Anne Frank',
        authorRole: 'Diarist',
        authorImage: anneFrank
    },
    {
        quote: 'Action is the foundational key to all success.',
        author: 'Pablo Picasso',
        authorRole: 'Painter',
        authorImage: picasso
    },
    {
        quote: 'Improved productivity means less human sweat, not more.',
        author: 'Henry Ford',
        authorRole: 'Businessman',
        authorImage: henryFord
    },
    {
        quote: 'Choose to be optimistic, it feels better.',
        author: 'Dalai Lama',
        authorRole: 'Monk',
        authorImage: dalaiLama
    },
    {
        quote: 'I’m ready! I’m ready! I’m ready!',
        author: 'SpongeBob SquarePants',
        authorRole: 'Seasponge',
        authorImage: spongebob
    },
    {
        quote: 'There’s a crack in everything, that’s how the light gets in.',
        author: 'Leonard Cohen',
        authorRole: 'Poet & Musician',
        authorImage: cohen
    },
    {
        quote: 'Today is a good day to try.',
        author: 'Quasimodo',
        authorRole: 'Belltower Hunchback',
        authorImage: quasimodo
    },
    {
        quote: 'It’s not that I’m so smart, it’s just that I stay with problems longer.',
        author: 'Albert Einstein',
        authorRole: 'Certified Genius',
        authorImage: einstein
    },
    {
        quote: 'Learning never exhausts the mind.',
        author: 'Leonardo Da Vinci',
        authorRole: 'Certified Genius',
        authorImage: daVinci
    },
    {
        quote: 'Why do anything unless it is going to be great?',
        author: 'Peter Block',
        authorRole: 'Author',
        authorImage: peterBlock
    }
];

const randomQuoteIndex = Math.floor(Math.random() * quotes.length);

export default class AppLoading extends PureComponent {
    static defaultProps = {
        showQuote: true
    };

    static contextTypes = {
        router: PropTypes.object
    };

    renderQuote(quote) {
        return (
            <div className="app-quote">
                <div className="app-quote-main">{quote.quote}</div>

                <div className="app-quote-author">
                    <div className="author-avatar">
                        <img src={quote.authorImage} alt={quote.author} />
                    </div>

                    <div className="author-main">
                        <h5>{quote.author}</h5>
                        <h6>{quote.authorRole}</h6>
                    </div>
                </div>
            </div>
        )
    }

    get content() {
        if (this.context.router.getCurrentLocation().pathname === 'dashboard-new') {
            return (
                <div className="app-loading-content">
                    <h4>Creating your dashboard...</h4>
                </div>
            );
        }
        if (this.context.router.getCurrentLocation().pathname === 'signup/theme') {
            return (
                <div className="app-loading-content">
                    <h4>Creating your team...</h4>
                </div>
            );
        }

        if (this.props.showQuote) {
            return (
                <div className="app-loading-content">
                    { this.renderQuote(quotes[randomQuoteIndex]) }
                </div>
            );
        }

        return null;
    }

    render() {
        return (
            <div className="app-loading">
                <div className="app-loading-loader">
                    <span className="loader-dot" />
                    <span className="loader-dot" />
                    <span className="loader-dot" />
                </div>

                { this.content }
            </div>
        )
    }
}
